export default "/_next/static/assets/hou-logo_8da1602103aa36571c2af9ae079c472c.webp";